import styles from "components/Form/Form.module.scss";

export const formConfig = {
  name: {
    title: "Name",
    elementType: "input",
    elementConfig: {
      id: "name",
      type: "text",
      value: "",
      placeholder: "Enter name",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: false,
    },
    valid: false,
    touched: false,
    error: {
      message: "Name is required",
    },
  },
  user_id: {
    title: "User",
    elementType: "input",
    elementConfig: {
      id: "user_id",
      type: "text",
      value: "",
      "data-id": "",
      autoComplete: "off",
      placeholder: "Search User",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: false,
    },
    dropdown: true,
    valid: false,
    touched: false,
    error: {
      message: "User is required",
    },
  },
  type: {
    title: "Type",
    elementType: "select",
    elementConfig: {
      id: "type",
      value: "",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.select],
    validation: {
      required: false,
    },
    options: [
      { value: "", text: "select type" },
      { value: "callback", text: "Callback" },
      { value: "uuid-standby", text: "UUID Standby" },
    ],
    valid: true,
    touched: false,
    error: {
      message: "",
    },
  },
  contact: {
    title: "Contact",
    elementType: "input",
    elementConfig: {
      id: "contact",
      type: "text",
      value: "",
      placeholder: "Enter contact",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    error: {
      message: "",
    },
  },
  status: {
    title: "Status",
    elementType: "select",
    elementConfig: {
      id: "status",
      value: "",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.select],
    validation: {
      required: false,
    },
    options: [
      { value: "", text: "select status" },
      { value: "Logged Out", text: "Logged Out" },
      { value: "Available", text: "Available" },
      { value: "Available (On Demand)", text: "Available (On Demand)" },
      { value: "On Break", text: "On Break" },
    ],
    valid: true,
    touched: false,
    error: {
      message: "",
    },
  },
  no_answer_delay_time: {
    title: "No Answer Delay Time",
    elementType: "input",
    elementConfig: {
      id: "no_answer_delay_time",
      type: "number",
      step: 1,
      min: 1,
      value: 3,
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    error: {
      message: "",
    },
  },
  max_no_answer: {
    title: "Max No Answer",
    elementType: "input",
    elementConfig: {
      id: "max_no_answer",
      type: "number",
      step: 1,
      min: 1,
      value: 3,
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    error: {
      message: "",
    },
  },
  wrap_up_time: {
    title: "Wrap Up Time",
    elementType: "input",
    elementConfig: {
      id: "wrap_up_time",
      type: "number",
      step: 1,
      min: 1,
      value: 10,
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    error: {
      message: "",
    },
  },
  reject_delay_time: {
    title: "Reject Delay Time",
    elementType: "input",
    elementConfig: {
      id: "reject_delay_time",
      type: "number",
      step: 1,
      min: 1,
      value: 10,
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    error: {
      message: "",
    },
  },
  busy_delay_time: {
    title: "Busy Delay Time",
    elementType: "input",
    elementConfig: {
      id: "busy_delay_time",
      type: "number",
      step: 1,
      min: 1,
      value: 60,
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    error: {
      message: "",
    },
  },
  enabled: {
    title: "Is Enabled",
    elementType: "select",
    elementConfig: {
      id: "enabled",
      value: true,
    },
    labelClasses: [styles.label],
    elementClasses: [styles.select],
    validation: {
      required: false,
    },
    options: [
      { value: "false", text: "No" },
      { value: "true", text: "Yes" },
    ],
    valid: true,
    touched: false,
    error: {
      message: "",
    },
  },
  domain_id: {
    title: "Domain",
    elementType: "input",
    elementConfig: {
      id: "domain_id",
      type: "text",
      value: "",
      "data-id": "",
      autoComplete: "off",
      placeholder: "Search domain ID",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    error: {
      message: "",
    },
  },
};
